export type SignInRequestType = {
  username: string;
  password: string;
};

export type SignInResponseType = {
  accessToken: string;
  idToken: string;
  refreshToken: string;
  expiresIn: number;
  tokenType: string;
};

export type MfaResponseType = {
  challengeName: string;
  session: string;
  userId: string;
};

export type SignInResponseTypeWrapper = {
  auth: SignInResponseType;
  mfa: MfaResponseType;
};

export const SIGNIN_REQUEST = "SIGNIN_REQUEST";
